import React from 'react';
import Image from 'next/image';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import { Cta } from '../cta/cta';
import { SignupButton } from '../../../components/web/button/signup-button';
import { WebButton } from '../../../components/web/button/web-button';
import { IconNext } from '../../../components/app/icons/next';
import { IconDiscord } from '../../../components/app/icons/discord';
import { useRootStore } from '../../../providers/root-store-provider';

export const Community: React.FC = observer(() => {
    const { t, i18n } = useTranslation();
    const { homepageStore } = useRootStore();
    const count = homepageStore.roundedCount;

    return (
        <Cta
            compact
            titleGrey={
                <span className="inline-flex max-w-full flex-col items-start gap-[1.2rem] rounded-[2rem] border border-[#d9cdc5] pl-[0.8rem] pr-[1.6rem] py-[0.6rem] sm:flex-row sm:items-center sm:gap-[1.6rem] sm:rounded-full">
                    <span aria-hidden="true" className="flex shrink-0 items-center">
                        {[1, 2, 3, 4, 5, 6].map((person) => (
                            <span
                                key={person}
                                className="relative -ml-[1.2rem] h-[3.2rem] w-[3.2rem] overflow-hidden rounded-full border-2 border-[#fdf7f2] first:ml-0"
                            >
                                <Image src={`/images/join-us/person-${person}.png`} alt="" width={32} height={32} />
                            </span>
                        ))}
                    </span>
                    <span className="text-[1.5rem] font-semibold leading-relaxed text-brand-secondary">
                        {count > 0 ? (
                            <Trans
                                i18nKey="pages.homepage.community.members"
                                values={{ countOfUsers: new Intl.NumberFormat(i18n.language).format(count) }}
                                components={{ strong: <strong className="font-bold text-brand-primary" /> }}
                            />
                        ) : (
                            t('pages.homepage.community.intro')
                        )}
                    </span>
                </span>
            }
            title={t('pages.homepage.community.title')}
            actions={
                <div className="flex w-full shrink-0 flex-col gap-[1.2rem] sm:w-auto sm:flex-row">
                    <SignupButton
                        variant="primary"
                        size={{ xs: 'medium', sm: 'vlarge' }}
                        icon={<IconNext />}
                        iconGap="xsmall"
                    >
                        {t('pages.homepage.cta.button')}
                    </SignupButton>
                    <WebButton
                        variant="secondary"
                        variation="outlined"
                        tone="neutral"
                        size={{ xs: 'medium', sm: 'vlarge' }}
                        icon={<IconDiscord />}
                        iconGap="xsmall"
                        href="https://discord.gg/n4MYgUh9KF"
                    >
                        {t('pages.homepage.community.button')}
                    </WebButton>
                </div>
            }
        />
    );
});
